import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import AssociationGridViewModelType from '@/ViewModels/Controls/AssociationGridViewModel';
import FilterType from '@/Controls/Filter';
import ToolBarType from '@/Controls/ToolBar';
import CoreFrameGridType from '@/Controls/CoreFrameGridControl';
import EventHelper from '@/Utility/EventHelper';
import Messenger from '@/Utility/Messenger';
import {DisposeBehavior} from '#/DefaultViewExtensionInterfaces';

export default class AssociationGrid extends Control {
    protected Filter = ComponentManager.getControl<typeof FilterType>('Filter');
    protected ToolBar = ComponentManager.getControl<typeof ToolBarType>('ToolBar');
    protected CoreFrameGrid = ComponentManager.getControl<typeof CoreFrameGridType>('CoreFrameGrid');
    private jQueryControl: JQuery;
    private filter: FilterType;
    private toolBar: ToolBarType;
    public grid: CoreFrameGridType;
    private static AppliedMessageId = 'DetailViewContextAppliedMessage';
    private messageIsRegistered: boolean;

    public constructor(protected viewModel: AssociationGridViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        $('<div class="toolbar">').appendTo(this.jQueryControl);
        $('<div class="filter"><div></div></div>').appendTo(this.jQueryControl);
        $('<div class="grid"><div></div></div>').appendTo(this.jQueryControl);

        Messenger.registerForMessageId(AssociationGrid.AppliedMessageId,
            (message) => {
                const vm = this.viewModel;
                if (vm)
                    vm.notNavigateableAssociations = [];
            },
            this);
        this.messageIsRegistered = true;

        this.widget(null);

        return this.jQueryControl;
    }

    /**
     * @override
     */
    public disposeInternal(): void {
        if (this.messageIsRegistered)
            Messenger.unregisterForMessageId(AssociationGrid.AppliedMessageId, null, this);

        super.disposeInternal();
    }

    protected getDisposeBehavior(): DisposeBehavior {
        return "Asynchronous";
    }

    protected onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            controlName: 'associationgrid',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.dataGrid.filter != null) {
            this.filter = new this.Filter(this.viewModel.dataGrid.filter, this.jQueryControl.find('.filter'));
            this.filter.getTupleAsync();
        }

        if (this.viewModel.toolBar != null) {
            this.toolBar = new this.ToolBar(this.viewModel.toolBar, this.jQueryControl.find('.toolbar'));
            this.toolBar.getTuple();
        }

        if (this.viewModel.dataGrid != null) {
            this.grid = new this.CoreFrameGrid(this.viewModel.dataGrid, this.jQueryControl.find('.grid > div'));
            this.grid.getTuple();
        }

        if (this.viewModel.isDropable) {
            EventHelper.bindDropAndAddEvent(this.jQueryControl,
                this.defineComputed(() => {
                    const createAndConnect = this.viewModel.toolBar.getElementByErgName('CREATE_NEW_AND_CONNECT');
                    return createAndConnect.isEnabled() && createAndConnect.isVisible();
                }),
                this.viewModel.checkDraggedElementsAllowed, null, null, this.viewModel.onDrop.bind(this.viewModel));
        } else {
            EventHelper.bindDropNotPossible(this.jQueryControl);
        }
    }
    
    /**
     * @override
     */
}

ComponentManager.setControl('AssociationGrid', AssociationGrid, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setControl('AssoziationGrid', AssociationGrid, 'RADPresentation.HTMLClient.DefaultViewExtensions');